<template>
  <div id="modify-profile">
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="250px"
             class="demo-ruleForm">
      <el-form-item label="Login Email:">
        <span>{{ruleForm.loginEmail}}</span>
      </el-form-item>
      <el-form-item label="Contact Email:"
                    prop="contactEmail">
        <el-input v-model="ruleForm.contactEmail"
                  autocomplete="on"></el-input>
      </el-form-item>
      <el-form-item label="Name:">
        <span>{{ruleForm.userName}}</span>
      </el-form-item>
      <el-form-item label="Time zone difference"
                    prop="hourDiff">
        <el-select v-model="ruleForm.hourDiff"
                   placeholder="0">
          <el-option v-for="item in timeList"
                     :key="item"
                     :label="item"
                     :value="item"></el-option>
        </el-select>
        <div class="tips">
          0 hours means same time as Beijing. +1 hour means 1 hour ahead of Beijing time, -1 hour means you are 1 hour behind Beijing time.
        </div>
      </el-form-item>
      <el-form-item label="Skype ID:"
                    prop="skype">
        <el-input v-model="ruleForm.skype"
                  autocomplete="on"></el-input>
      </el-form-item>
      <el-form-item label="Microsoft Teams:"
                    prop="microsoftTeams">
        <el-input v-model="ruleForm.microsoftTeams"
                  autocomplete="on" maxlength="120"></el-input>
      </el-form-item>
      <el-form-item label="QQ:"
                    prop="qq">
        <el-input v-model="ruleForm.qq"
                  autocomplete="on"></el-input>
      </el-form-item>
      <el-form-item label="Mobile:"
                    prop="phone">
        <el-input v-model="ruleForm.phone"
                  autocomplete="on"></el-input>
      </el-form-item>
      <el-form-item label="notification for students:"
                    prop="content">
        <el-input type="textarea"
                  v-model="ruleForm.content"
                  maxlength='200'
                  show-word-limit
                  :rows="3"
                  placeholder="Please do not over 200 words"></el-input>
      </el-form-item>
      <el-form-item label="Nationality:"
                    prop="nationality">
        <el-input v-model="ruleForm.nationality"></el-input>
      </el-form-item>
    </el-form>
    <span class="show-examine">{{ruleForm.examineStatus | getExamText}}</span>
    <span style="color:red"
          v-if="ruleForm.examineRemark!==''&& ruleForm.examineRemark!==null">({{ruleForm.examineRemark}})</span>
    <el-button class="submit-btn"
               :loading="submitLoading"
               @click="submitForm('ruleForm')">Submit</el-button>
  </div>
</template>
<script>
import './index.less';
export default {
  created() {
    this.initData();
    this.getDetail();
  },
  filters: {
    getExamText(val) {
      if (val === 0) {
        return 'apply for approval';
      } else if (val === 1) {
        return 'approved';
      } else if (val === 2) {
        return 'disapproved';
      }
    },
  },
  data() {
    var validateEmail = (rule, value, callback) => {
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
      if (!reg.test(value)) {
        return callback(new Error('wrong email address!'));
      } else {
        return callback();
      }
    };
    var validateQQ = (rule, value, callback) => {
      var reg = /^[1-9]\d{4,12}$/;
      if (value && !reg.test(value)) {
        return callback(new Error('wrong QQ number!'));
      } else if (!value && !this.ruleForm.microsoftTeams) {
        return callback(new Error('One of QQ and Microsoft Teams is required '));
      } else {
        return callback();
      }
    };
    var validateMicrosoftTeams = (rule, value, callback) => {
      if (!value && !this.ruleForm.qq) {
        return callback(new Error('One of QQ and Microsoft Teams is required '));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        contactEmail: '',
        hourDiff: 0,
        skype: '',
        microsoftTeams: '',
        qq: '',
        phone: '',
        content: '',
        nationality: '',
      },
      rules: {
        contactEmail: [
          { required: true, message: 'please input contact email!', trigger: 'blur' },
          { validator: validateEmail, trigger: 'blur' },
        ],
        phone: [
          { required: true, message: 'please input mobile!', trigger: 'blur' },
          { min: 1, max: 20, message: 'The mobile must be less than 20 characters in length.', trigger: 'blur' },
        ],
        nationality: [
          { required: true, message: 'please input nationality!', trigger: 'blur' },
        ],
        qq: [{ validator: validateQQ, trigger: 'blur' }],
        microsoftTeams: [
          { validator: validateMicrosoftTeams, trigger: 'blur' },
          { min: 1, max: 120, message: 'Length cannot be longer than 120 characters', trigger: 'blur' },
        ],
      },
      timeList: [],
      experienceList: [],
      submitLoading: false,
    };
  },
  methods: {
    async getDetail() {
      const res = await this.$api.getProfileDetail();
      this.ruleForm = res.data.resultData;
    },
    initData() {
      for (var i = -24; i <= 12; i++) {
        this.timeList.push(i);
      }
      for (var i = 1; i <= 11; i++) {
        if (i === 11) {
          this.experienceList.push('10+');
        } else {
          this.experienceList.push(i);
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.preserveForm();
        } else {
          return false;
        }
      });
    },
    async preserveForm() {
      try {
        await this.$api.modifyProfile(this.ruleForm);
        this.$alert('Submitted successfully!', 'Notice', {
          confirmButtonText: 'OK',
          customClass: 'notice-message',
          callback: (action) => {},
        });
      } catch (e) {
        console.log(e);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/global-components/ModifyInfo/ModifyProfile/index.vue